import {
  forwardRef,
  useCallback,
} from 'react';
import type {
  ChangeEventHandler,
  ForwardedRef,
  ReactElement,
} from 'react';

import MaskedInput from 'react-text-mask';
import type {
  MaskedInputProps,
} from 'react-text-mask';

export const dateMask = [/[0-3]/, /\d/, '.', /[0-1]/, /\d/, '.', /\d/, /\d/, /\d/, /\d/];
export const dateWithTimeMask = [/[0-3]/, /\d/, '.', /[0-1]/, /\d/, '.', /\d/, /\d/, /\d/, /\d/, ' ', /[0-2]/, /\d/, ':', /[0-5]/, /\d/];

const datePlaceholder = '__.__.____';
const dateWithTimePlaceholder = '__.__.____ __:__';

export type DatepickerInputMaskProps = Omit<MaskedInputProps, 'mask'> & {
  withTime?: boolean;
  autoComplete?: 'on' | 'off';
  onChange?: ChangeEventHandler<HTMLInputElement>;
};

function DatepickerInputMaskInner(
  {
    autoComplete = 'off',
    withTime = false,
    onChange: onChangeProp = undefined,
    ...rest
  }: DatepickerInputMaskProps,
  ref: ForwardedRef<MaskedInput>,
): ReactElement {
  const onChange = useCallback<ChangeEventHandler<HTMLInputElement>>((event) => {
    const placeholder = withTime ? dateWithTimePlaceholder : datePlaceholder;

    // https://github.com/Hacker0x01/react-datepicker/issues/1185
    if (event.target.value === placeholder) {
      // eslint-disable-next-line no-param-reassign
      event.target.value = '';
    }

    if (onChangeProp) {
      onChangeProp(event);
    }
  }, [
    withTime,
    onChangeProp,
  ]);

  return (
    <MaskedInput
      {...rest}
      autoComplete={autoComplete}
      mask={withTime ? dateWithTimeMask : dateMask}
      onChange={onChange}
      ref={ref}
    />
  );
}

export const DatepickerInputMask = forwardRef(DatepickerInputMaskInner);
